export const SALES_GOALS_USD_CURRENCY_FORMAT = { type: 'currency', currency: 'USD' };
export const DX_USD_CURRENCY_FORMAT = {
  type: 'currency',
  currency: 'USD',
  precision: 2,
  useCurrencyAccountingStyle: false,
};
